import React from "react";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { Pressable, Text } from "react-native";
import { GlobalStyles, Transition } from "../style/Style";

interface ButtonProps {
    label: string;
    icon: JSX.Element;
    onPress: () => void;
}

export const MenuItem: React.FC<ButtonProps> = ({ label, icon, onPress }) => {
    const styles = useDynamicStyles(generateStyles);

    return (
        <Pressable style={[styles.menuItemContainer, Transition()]} onPress={onPress}>
            {icon}
            <Text style={styles.label}>{label}</Text>
        </Pressable>
    );
};

const generateStyles = () => {
    return EStyleSheet.create({
        menuItemContainer: {
            width: "100%",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 20,
        },
        label: {
            flexGrow: 1,
            paddingLeft: 10,
            fontSize: 14,
            fontWeight: 600,
            color: () => EStyleSheet.value(GlobalStyles.BASE_COLOUR),
        },
    });
};
